import { ArrowsAltOutlined, CalculatorOutlined, LogoutOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Calculator } from 'react-mac-calculator';
import ValKurses from './ValKurses';
import Time from './Time';
import Notes from './Notes/Notes';

function LeftToolbar() {
    let [calcmodal, setCalcModal] = useState(false);

    const handleFullScreen = () => {
        const el = document.documentElement;
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            if (el.requestFullscreen) {
                el.requestFullscreen();
            } else if (el.webkitRequestFullscreen) {
                el.webkitRequestFullscreen();
            } else if (el.msRequestFullscreen) {
                el.msRequestFullscreen();
            }
        }
    };

    return (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Time />
            <Notes />
            <ValKurses />

            <Button
                type='text'
                icon={<ArrowsAltOutlined style={{ fontSize: '16px' }} />}
                onClick={handleFullScreen}
                style={{
                    color: 'var(--text-secondary)',
                    borderRadius: 'var(--radius-md)',
                }}
            />

            <Button
                type='text'
                icon={<CalculatorOutlined style={{ fontSize: '16px' }} />}
                onClick={() => setCalcModal(true)}
                style={{
                    color: 'var(--text-secondary)',
                    borderRadius: 'var(--radius-md)',
                }}
            />

            <NavLink to={'/pos'}>
                <Button
                    type='primary'
                    icon={<ShoppingCartOutlined style={{ fontSize: '16px' }} />}
                    style={{ borderRadius: 'var(--radius-md)' }}
                >
                    POS
                </Button>
            </NavLink>

            <Button
                type='text'
                danger
                icon={<LogoutOutlined style={{ fontSize: '16px' }} />}
                onClick={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    window.location.href = '/login';
                }}
                style={{
                    borderRadius: 'var(--radius-md)',
                }}
            />

            <Modal
                open={calcmodal}
                footer={null}
                title={'Kalkulator'}
                onCancel={() => setCalcModal(false)}
                width={370}
            >
                <Calculator style={{ width: '100%', height: '100%' }} />
            </Modal>
        </div>
    );
}

export default LeftToolbar;
